<div class="change_filter_page">
    <app-header [headerTitle]="headerTitle" [showBackButton]="showBackButton"></app-header>

    <div class="filter_container_main">
        <div class="filter_container">
            <div class="left_side">

                <div class="filterdiv_container">
                    <div class="filter_head">
                        <span class="head">Organization</span>
                        <mat-checkbox aria-label="Select All" [checked]="isChecked()"
                            [indeterminate]="isIndeterminate()" (change)="toggleAll($event)" class="main_checkbox">
                            <span class="select_all"> Select All</span>
                        </mat-checkbox>
                    </div>
                </div>

                <!-- <fieldset class="demo-fieldset"> -->
                <div class="demo-select-all-checkboxes">
                    <div *ngFor="let item of itemsObject">
                        <span class="" tabindex="1">
                            <mat-checkbox 
                                class="checkbox_category cross checkbox_option" [checked]="item.selected" (change)="toggle(item)" >
                                {{ item.val }}
                            </mat-checkbox>
                        </span>

                    </div>
                </div>

                <!-- </fieldset> -->
            </div>
            <div class="right_side">
                <div class="show_result">Show Result</div>

                <div class="programs_container">
                    <h2 class="program">PROGRAM</h2>

                    <div class="search_container">
                        <input type="text" placeholder="Search Program" class="search">
                        <img src="../../assets/images/program_search.svg" alt="" class="search_icon">
                    </div>

                    <div class="program_selection">
                        <!-- <div *ngFor="let item of programCheckbox"> -->
                        <div *ngFor="let item of programCheckbox" class="" tabindex="1">
                            <mat-checkbox [checked]="item.selected" (change)="toggle(item)" class="checkbox_category cross program_checkbox_option">
                                {{ item.val }}
                            </mat-checkbox></div>

                        <!-- </div> -->
                    </div>


                </div>
            </div>
        </div>
    </div>

</div>